import { Link, href, useNavigate } from "react-router";
import { useAuth } from "../lib/AuthContext";

enum NavbarPage {
  People = "People",
  Guide = "Guide",
  Progress = "Progress",
  LogIn = "Log in",
}

const links: NavbarPage[] = [
  NavbarPage.People,
  NavbarPage.Guide,
  NavbarPage.Progress,
  NavbarPage.LogIn,
];

interface PrelaunchNavbarProps {
  transparent?: boolean;
  absolute?: boolean;
  showLogo?: boolean;
  ref?: React.RefObject<HTMLDivElement | null>;
}

const PrelaunchNavbar: React.FC<PrelaunchNavbarProps> = ({
  transparent = true,
  absolute = true,
  showLogo = true,
  ref,
}: PrelaunchNavbarProps) => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const destinations: Record<NavbarPage, string> = {
    [NavbarPage.People]: href("/people"),
    [NavbarPage.Guide]: href("/guide"),
    [NavbarPage.Progress]: href("/progress"),
    [NavbarPage.LogIn]: isAuthenticated ? href("/tasks") : href("/login"),
  };

  return (
    <div
      className={`
      flex flex-col sm:flex-row md:gap-y-4 ${absolute ? "absolute" : "relative"}
      w-screen ${
        showLogo ? "justify-between" : "justify-end"
      } items-center py-4 md:py-5 px-24 top-0 left-0 z-10 text-[14pt] transition-[padding,background-color] duration-300 ${
        transparent
          ? "bg-transparent text-white"
          : "text-black bg-white border-b md:border-none border-zinc-200"
      }`}
      ref={ref}
    >
      {showLogo && (
        <h1
          className="font-bold font-berlingske text-lg md:text-2xl cursor-pointer text-nowrap"
          onClick={() => {
            navigate(href("/"));
          }}
        >
          THE ALLIANCE
        </h1>
      )}
      <div className="flex flex-row items-center gap-x-5 sm:gap-x-10 text-base sm:text-lg">
        {links.map((link) => (
          <>
            {link == NavbarPage.LogIn ? (
              <Link
                to={destinations[link]}
                key={link}
                className="border border-zinc-200 bg-white hover:bg-zinc-50 py-1 md:py-1.5 px-3 md:px-5 rounded-full whitespace-nowrap"
              >
                {link}
              </Link>
            ) : (
              <Link
                to={destinations[link]}
                key={link}
                className="hover:underline whitespace-nowrap"
              >
                {link}
              </Link>
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default PrelaunchNavbar;
